import { useEffect, useState } from 'react';

/** The time now, read again every `intervalMs` (the countdowns of Up next, design s3, s4b). */
export function useNow(intervalMs: number): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
